module.exports = __webpack_public_path__ + "static/media/YandexMail-dark.37c98e3f.png";